import { memo } from "react";

const AboutPage = memo(() => {
    return <div></div>;
});

export default AboutPage;
